import * as React from 'react'
import type {TWaitingRoomResponse} from '@kapitalist/contract/endpoints'
import type {TGameId} from '@kapitalist/contract/types'
import api from '~/api/endpoints'
import DashboardLayout from '~/layouts/DashboardLayout'
import WaitingRoomUI from '~/pages/WaitingRoom/stateless'
import type {IWaitingRoomPagePathPieces} from '~/pages/WaitingRoom/types'
import {navigateReplace} from '~/routing/navigate'
import type {ISignedInRouteComponentProps} from '~/routing/Route/SignedIn'
import {dynamicURLs} from '~/routing/sitemap'

interface IProps extends ISignedInRouteComponentProps<IWaitingRoomPagePathPieces> {}

interface IState {
  currentData: TWaitingRoomResponse | undefined

  // as soon as you join a game, refresh the waiting room data immediately
  justJoined: boolean
}

export default class WaitingRoomPage extends React.Component<IProps, IState> {
  state: IState = {
    currentData: undefined,
    justJoined: false,
  }

  receiveNewData = (currentData: TWaitingRoomResponse) => {
    if (currentData.status === 'started') {
      this.gameStartedHandler(currentData.gameId)
    } else {
      this.setState({currentData})
    }
  }

  gameStartedHandler = (gameId: TGameId) => {
    navigateReplace(dynamicURLs.game.lobbyV2({maybeGameId: gameId}))
  }

  render() {
    const {justJoined} = this.state
    const maybeGameId = this.props.match.params.maybeGameId

    return (
      <api.preGame.getWaitingRoomData.PromiseManager
        params={{}}
        pathPieces={{maybeGameId}}
        onSuccess={this.receiveNewData}
        then={justReceivedData => {
          const gameId = (this.state.currentData ?? justReceivedData).gameId

          return (
            <DashboardLayout {...this.props}>
              <api.preGame.getWaitingRoomData.PromisePoller
                params={{}}
                pathPieces={{maybeGameId: gameId}}
                refreshTrigger={justJoined}
                onSuccess={this.receiveNewData}
                frequencyMs={[1000, 1000, 3000, 5000, -1]}
                pollImmediatelyOnMount={false}
              >
                <WaitingRoomUI
                  data={this.state.currentData ?? justReceivedData}
                  authenticatedPlayer={this.props.authenticatedPlayer}
                  startGame={() => api.preGame.startGame.execute({}, {gameId})}
                  gameStarted={() => this.gameStartedHandler(gameId)}
                  joinGame={() =>
                    api.preGame.joinGame.execute({}, {maybeGameId: gameId})
                  }
                  joinGameSuccess={() => this.setState({justJoined: true})}
                  kickPlayer={playerId =>
                    api.preGame.kickPlayer
                      .execute({}, {gameId, playerId})
                      .then(this.receiveNewData)
                  }
                />
              </api.preGame.getWaitingRoomData.PromisePoller>
            </DashboardLayout>
          )
        }}
      />
    )
  }
}
